import React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  SelectProps
} from "@mui/material";

export interface MultiselectDropdownProps extends SelectProps {
  helperText?: string;
}

export const MultiselectDropdown = ({
  value,
  label,
  labelId,
  helperText,
  error,
  children,
  ...selectProps
}: MultiselectDropdownProps): JSX.Element => {
  return (
    <FormControl fullWidth variant="outlined" size="small">
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        labelId={labelId}
        multiple
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left"
          }
        }}
        error={error}
        {...selectProps}
      >
        {children}
      </Select>
      {helperText && (
        <FormHelperText error={error}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};
